/*========================================================================
 * $Id: piechart.js -1M 2016-03-11 18:13:13Z (local) $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/


define([
  "client/templateregistry",
  "api/v2/search",
  "client/template",
  "component!base",
  "utils/boolean",
  "i18n/i18n",
  "jquery",
  "service/channel",
  "underscore",
  "utils/dom",
], function (
  TemplateRegistry,
  Search,
  Template,
  Base,
  Boolean,
  i18n,
  $,
  Channel,
  _,
  dom
) {

  var Chart = Template.extend({

    editableName: "editor_charts",

    initialize: function () {
      this.initializationPromise = new Channel.DeferredCallFinished();
      Template.prototype.initialize.apply(this, _.toArray(arguments));
      var that = this;

      Mindbreeze.require(["highcharts"], function () {
        that.initializationPromise.triggerDone();
      });

    },


    schema: new Template.Schema({
      inputAttributes: {
        chartTitle: {
          title: "editor_chart_title",
          type: "string"
        },
        chartSourceName: {
          title: "editor_chart_source_name",
          type: "enum",
          values: {
            bind: {
              options: "available_facets",
              value: "name",
              text: "localized_name"
            }
          },
          depends: "(!attributes['enableCustomSourceName'] && !attributes['enablecustomsourcename']) || /^false$/i.test(attributes['enableCustomSourceName']) || /^false$/i.test(attributes['enablecustomsourcename'])"
        },
        enableCustomSourceName: {
          title: "editor_use_custom_sourcename",
          type: "boolean",
          defaultValue: false,
          "default": false
        },
        customSourceName: {
          title: "editor_custom_sourcename",
          type: "string",
          depends: "/^true$/i.test(attributes['enableCustomSourceName']) || /^true$/i.test(attributes['enablecustomsourcename'])"
        },
        chartheight: {
          title: "editor_chart_height",
          type: "int"
        },
        titlealign: {
          title: "editor_title_align",
          type: "enum",
          values: [{
            value: "center",
            text: i18n("Center")
          }, {
            value: "left",
            text: i18n("Left")
          }, {
            value: "right",
            text: i18n("Right")
          }]
        },
        showlegend: {
          title: "editor_show_legend",
          type: "boolean",
          defaultValue: false,
          "default": false,
          depends: "'pie' === attributes['charttype']"
        },
        "orderdirection": {
          type: "list",
          title: "order_direction",
          values:  [
            { value: "ASCENDING", text: i18n("sort_ascending") },
            { value: "DESCENDING", text: i18n("sort_descending") }
          ],
        },
        colors: {
          type: "string",
          depends: "'pie' === attributes['charttype']",
          visible: false
        }
      }
    }),

    getOptions: function (options) {
      options = _.extend({},
        Template.prototype.getOptions.apply(this, arguments),
        this.attributeModel.get()
      );
      return this.schema.parseAttributes(options);

    },

    remove: function (options) {
      _.forEach(this.instances, function (view) {
        view.remove();
      });
      this.instances = [];
      var nodeChildren = options && options.node && options.node.children;
      _.forEach(nodeChildren, function (childNode) {
        childNode.template.remove({
          node: childNode
        });
      });
    }

  });

  var ChartsView = Base.extend({

    initialize: function () {
      Base.prototype.initialize.apply(this, arguments);
      var enableCustomSourceName = Boolean.boolParser(this.options.enablecustomsourcename) === true || Boolean.boolParser(this.options.enableCustomSourceName) === true;
      var customSourceName = this.options.customSourceName || this.options.customsourcename;
      var sourceName = this.options.chartsourcename || this.options.chartSourceName;
      this.name = enableCustomSourceName ? customSourceName : sourceName;
      this.source = this.options.chartsource || this.options.chartSource;
      this.hasCustomTheme = this.options.application.hasThemeDescriptor();
      var name2 = this.options.chartsourcename2 || this.options.chartSourceName2;
      var name3 = this.options.chartsourcename3 || this.options.chartSourceName3;

      if (this.source == "facets2") {

        this.name = "filter_" + name + "_" + name2;
        this.model.set("computed_properties",
          [{
            "name": this.name,
            "expr": 'concat(' + name + ',";",' + name2 + ')'
          }]
          , {
            silent: true
          });
      }

      var facets = {};
      facets[this.name] = {
        format: "HTML"
      };
      var facetRegistriation = {
        cid: _.uniqueId('c'),
        facets: facets,
        name: this.name,
        properties: {
          count: {
            format: "PROPERTY"
          },
          excluded: {
            format: "PROPERTY"
          },
          html: {
            format: "HTML"
          },
          showAddAnd: {
            format: "PROPERTY"
          },
        },
        setView: function () {},
        clear: function () {},
        stopListening: function () {}
      };
      this.facetRegistriation = facetRegistriation;
      if (this.model.addFacet && (this.facetRegistriation.cid !== undefined)) this.model.addFacet(this.facetRegistriation, {
        silent: false
      });

      this.constraintsModel = this.model.input.submodel("user.constraints");

      this.listenTo(this.model, "change", this.render);

      $(window).resize(_.bind(function () {
        if (this.$el.highcharts()) {
          this.$el.highcharts().reflow();
        }
      }, this));

    },

    renderFacets: function () {
      var entries = this.model.get("entries") || this.model.get(["facets", this.name, "entries"]);

      entries = _.uniq(entries, function (item) {
        return item.html;
      });

      if (!entries || !entries.length) {
        var highchartsContainer = $(this.el).find('.mb-highcharts');
        if (highchartsContainer.length) {
          highchartsContainer.highcharts() && highchartsContainer.highcharts().destroy();
        }
        return;
      }

      var orderDirection = this.options.orderdirection;
      if (_.isArray(orderDirection) && orderDirection.length) {
        var isAscending = orderDirection[0] === "ASCENDING";
        entries.sort(function (a, b) {
          if (isAscending) {
            return a.html.localeCompare(b.html);
          } else {
            return b.html.localeCompare(a.html);
          }
        });
      }

      var that = this;
      var type = this.options.charttype;
      var chartTitle = this.options.charttitle || null;
      var chartWidth = this.options.chartwidth;
      var chartHeight = this.options.chartheight;
      var titleAlign = this.options.titlealign;
      var yAxisTitleText = this.options.yaxistitletext;
      var showInLegend = this.options.showlegend || false;
      var isPie = type === "pie";

      var resultMapWithNames = this.getResultMap(entries);
      var names = resultMapWithNames.names;
      var resultMap = resultMapWithNames.resultMap;

      var series = [];
      var isFilterEnabled = function (existingFilters, filterLabel, filterValue) {
        if (!existingFilters || typeof existingFilters !== 'object' || !filterLabel || !filterValue) {
          return false;
        }
        const newFilterString = `${filterLabel}.${filterValue}`
        // make filterstrings out of filter category and value to identify filter selections
        for (const key in existingFilters) {
          const subObj = existingFilters[key];
          if (!subObj?.filter_base || !subObj?.label) {
            continue;
          }
          for (const filterKey in subObj.filter_base) {
            let existingFilterString = `${subObj.label}.${filterKey}`;
            if (existingFilterString.toLocaleLowerCase() === newFilterString.toLocaleLowerCase()) {
              return true;
            }
          }
        }
        return false;
      };

      // darken the color of the selected bar/point to 40% brightness of the 
      // original color (#7cb5ec) to highlight the selected data
      const selectedElementColor = "#1969b3";
      // increase the size of the data point by 50% to make it more visible
      const selectedLineMarkerRadius = 6;
      // followup: make these values themeable

      var getChartSpecificData = function(type, name, resultMap, isFilterActive) {
        const count = resultMap[name]?.count;

        if (count === undefined) {
          return 0;
        }

        if (type === 'pie') {
          return {
            name,
            y: count,
            sliced: isFilterActive,
          };
        }

        if (!isFilterActive) {
          return count;
        }

        const dataPoint = {
          y: count,
          color: selectedElementColor
        };

        if (type === 'line') {
          dataPoint.marker = {
            enabled: true,
            radius: selectedLineMarkerRadius
          };
        }

        return dataPoint;
      };
 
      var seriesElement = {
        name: chartTitle,
        data: names.map(function(name) {
          let isFilterActive = isFilterEnabled(that.constraintsModel?.attributes, resultMap[name]?.filterLabel, resultMap[name]?.name);

          return getChartSpecificData(type, name, resultMap, isFilterActive);
        })
      };
      series.push(seriesElement);

      var handlePointClick = function () {
        var item = entries[this.index];
        var filterID = item.query_expr.label ? ("filter_" + item.query_expr.label) : _.uniqueId("cid");

        var filtered = {};
        _.each(entries, function (entry) {
          var query_expr = entry.query_expr;
          filtered[query_expr.id] = query_expr;
        });
        var filterbase = {};
        filterbase[item.query_expr.id] = item.query_expr;

        var filterExpr = {
          label: item.query_expr.label,
          filtered_name: item.query_expr.label,
          filtered: filtered,
          id: filterID,
          filter_base: filterbase
        };

        that.userConstraintInput = that.model.input.submodel("user.constraints");
        const filter = that.userConstraintInput.get(filterID);
        const isSameFilter = filter?.label === that.name;

        const baseFilter = filterExpr?.filter_base;
        const firstKey = baseFilter && Object.keys(baseFilter)[0];

        if (isSameFilter && isFilterEnabled(that.userConstraintInput.attributes, filterExpr?.label, firstKey)) {
          that.userConstraintInput.unset(filterID, options);
        } else {
          that.userConstraintInput.set(filterID, filterExpr);
        }
      };
      var colors = this.options.colors;
 
      if (colors) {
        colors = colors.split(";");
      }

      var options = {
        title: {
          text: chartTitle,
          align: titleAlign || "center"
        },
        chart: {
          type: type,
          height: chartHeight || 200,
          width: chartWidth || null,
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          spacingBottom: 10,
          spacingTop: 0,
          spacingLeft: 0,
          spacingRight: 0,
          marginTop: 30
        },
        yAxis: isPie ? undefined : {
          title: {
            text: yAxisTitleText || 'Count'
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        xAxis: isPie ? undefined : {
          categories: names
        },
        credits: false,
        plotOptions: {
          series: {
            point: {
              events: {
                click: handlePointClick
              }
            }
          },
          pie: {
            allowPointSelect: true,
            animation: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
            },
            showInLegend: showInLegend,
            colors: colors 
          }
        },
        legend: {
          enabled: isPie ? showInLegend : false
        },
        tooltip: {
          className: this.hasCustomTheme ? 'highchart-tooltip' : '',
          formatter: function () {
            if (this.point.name) {
              // Pie chart
              return this.point.name + ': ' + this.point.y;
            } else {
              // Bar, Line, and other charts
              return this.series.chart.xAxis[0].categories[this.point.index] + ': ' + this.y;
            }
          }
        },
        series: series
      };

      var container = $(this.el).find('.mb-highcharts');
      if (container.length === 0) {
        container = $(this.el).append("<div class='mb-highcharts'></div>");
      }
      $(this.el).find('.mb-highcharts').highcharts(options);
    },

    getResultMap: function (entries) {
      var result = {
        resultMap: [],
        names: []
      };

      for (var i = 0; i < entries.length; ++i) {
        var htmlDecodedValue = this.getDecodedHTML(entries[i].html);
        result.resultMap[htmlDecodedValue] = {
          count: entries[i].count,
          value: htmlDecodedValue,
          name: htmlDecodedValue
        };

        if (entries[i]?.query_expr?.label) {
          result.resultMap[htmlDecodedValue].filterLabel = entries[i].query_expr.label;
        }

        if (entries[i] && entries[i].count != null) {
          result.names.push(htmlDecodedValue);
        }
      }

      return result;
    },

    getDecodedHTML: function (html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },

    render: function () {
      return this.renderFacets();
    },

    remove: function () {
      if (this.constraintsModel) this.constraintsModel.dispose();
      this.el.innerHTML = "";
      if (this.model.removeFacet) this.model.removeFacet(this.facetRegistriation);
      if (this.$el.highcharts !== undefined && this.$el.highcharts() !== undefined) this.$el.highcharts().destroy();
      Base.prototype.remove.apply(this, arguments);
    }

  });

  Chart.View = ChartsView;

  TemplateRegistry.add({
    id: "charts",
    name: "editor_charts",
    weight: 6,

    getAdders: function (context) {
      return [{
        name: "editor_pie_title",
        icon: "../img/imgpiechart.png",
        group: {
          name: "Charts"
        },
        options: {
          charttype: "pie",
          template: "charts"
        },
      }, {
        name: "editor_bar_title",
        icon: "../img/imgbarchart.png",
        group: {
          name: "Charts"
        },
        options: {
          charttype: "bar",
          template: "charts"
        }
      }, {
        name: "editor_line_title",
        icon: "../img/imglinechart.png",
        group: {
          name: "Charts"
        },
        options: {
          charttype: "line",
          template: "charts"
        }
      }]
    },
    create: function (options) {
      var schema = new Template.Schema();
      options = options || {};
      var el = document.createElement("div");

      _.forEach(options, function (value, key) {
        el.setAttribute("data-" + dom.AttributeModel.camelCaseToSeparated(key), schema.serializeAttribute(value, key));
      });

      return el;
    }


  });

  return Chart;
});
